var chunkMapping = {
	"src_bootloader_ts": [
		"webpack/container/remote/SkynamoDesignSystem/SkynamoTooltip"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/SkynamoDesignSystem/SkynamoTooltip": [
		"default",
		"./SkynamoTooltip",
		"webpack/container/reference/SkynamoDesignSystem"
	]
};
var idToRemoteMap = {
	"webpack/container/remote/SkynamoDesignSystem/SkynamoTooltip": [
		{
			"externalType": "script",
			"name": "SkynamoDesignSystem",
			"externalModuleId": "webpack/container/reference/SkynamoDesignSystem"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}